import Close from "@material-symbols/svg-500/rounded/close.svg?react";
import { memo } from "react";

import { IconCreator } from "./_utils/icon-creator";

import type { SVGIconProps } from "./_utils/icon-creator";

const CloseIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Close });
	return <Icon />;
};

export default memo(CloseIcon);
